import React from "react";
import { Grid } from "@material-ui/core";
import { InputSelect, InputCheckbox } from "components/form";
import useBasicInformation from "./useBasicInformation";

import { Subtitle, Text, Small, GroupField } from "../../../Styled";

import {  PcdCidField } from "./Styled";
import { DatePicker } from "components/DatePicker";


const BasicInformation = () => {
    const {
        dataFields,
        errors,
        //getOptionOrgaoEmissor,
        getOptionsMaritalStatus,
        getHasCnhOption,
        getDriveLicenceCategories,
        getOptionsEducationLevel,
        getVvdmpOption,
        getColorRace,
        getOptionsBloodType,
        // nationalities,
        // listStates,
        // listCities,
        //listIssuingCities,
        birthDate,
        isCnhRequired,
        driverExpirationDate,
        translate,
        handleChangeText,
        handleChangeSelect,
        // handleChangeAutocomplete,
        // handleStateChangeSelect,
        handleChangeCheckbox,
        handleChangeDate,
        setDriverExpirationDate,
        setBirthDate,
        setCnhRequired,
    } = useBasicInformation();

    return (
        <React.Fragment>
            <Subtitle>
                {translate("workWithUs.form.step3.title")}
                <br />
                <Small>{translate("workWithUs.requiredFields")}</Small>
            </Subtitle>
            <Grid container spacing={2}>
                {/* <Grid item xs={12} md={12} lg={6} xl={6}>
                <GroupField>
                    <Input
                        fullWidth
                        transparent="true"
                        id="rg"
                        name="rg"
                        label={translate("workWithUs.form.step3.rg") + "(*)"}
                        autoComplete="off"
                        value={dataFields?.basicInformation?.rg || ""}
                        onChange={(props) => handleChangeText(props, "basicInformation")}
                        error={errors?.basicInformation?.rg}
                    />
                </GroupField>
                </Grid> */}

                {/* <Grid item xs={12} md={12} lg={6} xl={6}>
                <GroupField>
                    <InputAutoComplete
                        transparent="true"
                        name="rgIssuingAgency"
                        id="rgIssuingAgency"
                        label={translate("workWithUs.form.step3.rgIssuingAgency") + "(*)"}
                        value={dataFields?.basicInformation?.rgIssuingAgency || null}
                        onChange={(props, value) =>
                            handleChangeAutocomplete(
                                props,
                                value,
                                "rgIssuingAgency",
                                "basicInformation"
                            )
                        }
                        options={getOptionOrgaoEmissor}
                        error={errors?.basicInformation?.rgIssuingAgency}
                    />
                </GroupField>
                </Grid> */}

                {/* <Grid item xs={12} md={12} lg={4} xl={4}>
                <GroupField>
                    <InputSelect
                        fullWidth
                        transparent="true"
                        id="rgIssuingState"
                        name="rgIssuingState"
                        label={translate("workWithUs.form.step3.rgIssuingState") + " (*)"}
                        labeldark="false"
                        autoComplete="off"
                        value={dataFields?.basicInformation?.rgIssuingState || ""}
                        onChange={(props) =>
                            handleStateChangeSelect(
                            props,
                            "rgIssuingCity",
                            "basicInformation",
                            "fetchIssuingCities"
                            )
                        }
                        options={listStates}
                        error={errors?.basicInformation?.rgIssuingState}
                    />
                </GroupField>
                </Grid> */}

                {/* <Grid item xs={12} md={12} lg={4} xl={4}>
                <GroupField>
                    <InputAutoComplete
                        transparent="true"
                        name="rgIssuingCity"
                        id="rgIssuingCity"
                        label={translate("workWithUs.form.step3.rgIssuingCity") + " (*)"}
                        value={dataFields?.basicInformation?.rgIssuingCity || null}
                        onChange={(props, value) =>
                            handleChangeAutocomplete(
                            props,
                            value,
                            "rgIssuingCity",
                            "basicInformation"
                            )
                        }
                        options={listIssuingCities}
                        error={errors?.basicInformation?.rgIssuingCity}
                    />
                </GroupField>
                </Grid> */}

                <Grid item xs={12} md={12} lg={6} xl={6}>
                    <GroupField>
                        <InputSelect
                            fullWidth
                            transparent="true"
                            id="colorRace"
                            name="colorRace"
                            label={translate("workWithUs.form.step3.colorRace") + " (*)"}
                            labeldark="false"
                            autoComplete="off"
                            value={dataFields?.basicInformation?.colorRace || ""}
                            onChange={(props) => handleChangeText(props, "basicInformation")}
                            options={getColorRace}
                            error={errors?.basicInformation?.colorRace}
                            ></InputSelect>
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={6} xl={6}>
                    <GroupField>
                        <InputCheckbox
                            label="Você é uma pessoa com deficiência?"
                            name="isPcd"
                            checked={!!dataFields?.basicInformation?.isPcd}
                            onChange={(props) =>
                            handleChangeCheckbox(props, "basicInformation")
                            }
                        />
                    </GroupField>
                </Grid>

                {!!dataFields?.basicInformation?.isPcd && (
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <GroupField>
                            <PcdCidField
                                fullWidth
                                transparent="true"
                                id="pcdCid"
                                isvisible={`${!!dataFields?.basicInformation?.isPcd ? true : false}`}
                                name="pcdCid"
                                label={translate("workWithUs.form.step3.pcdCid")}
                                autoComplete="off"
                                value={(dataFields?.basicInformation?.isPcd && dataFields?.basicInformation?.pcdCid) || ""}
                                onChange={(props) => handleChangeText(props, "basicInformation")}
                                error={errors?.basicInformation?.pcdCid}
                            />
                        </GroupField>
                    </Grid>
                )}

                <Grid item xs={12} md={12} lg={!!dataFields?.basicInformation?.isPcd ? 6 : 9} xl={!!dataFields?.basicInformation?.isPcd ? 6 : 9}>
                    <GroupField>
                        <InputSelect
                            transparent="true"
                            name="bloodType"
                            id="bloodType"
                            label={translate("workWithUs.form.step3.bloodType")}
                            labeldark="false"
                            value={dataFields?.basicInformation?.bloodType || ""}
                            onChange={(props) =>
                            handleChangeSelect(props, "basicInformation")
                            }
                            options={getOptionsBloodType}
                            error={errors?.basicInformation?.bloodType}
                        />
                    </GroupField>
                </Grid>

                {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                    <Input
                        fullWidth
                        transparent="true"
                        id="motherName"
                        name="motherName"
                        label={translate("workWithUs.form.step3.motherName") + " (*)"}
                        autoComplete="off"
                        value={dataFields?.basicInformation?.motherName || ""}
                        onChange={(props) => handleChangeText(props, "basicInformation")}
                        error={errors?.basicInformation?.motherName}
                    />
                    </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                    <Input
                        fullWidth
                        transparent="true"
                        id="fatherName"
                        name="fatherName"
                        label={translate("workWithUs.form.step3.fatherName")}
                        autoComplete="off"
                        value={dataFields?.basicInformation?.fatherName || ""}
                        onChange={(props) => handleChangeText(props, "basicInformation")}
                        error={errors?.basicInformation?.fatherName}
                    />
                    </GroupField>
                </Grid> */}

                {/* <Grid item xs={12} md={12} lg={4} xl={4}>
                    <GroupField>
                        <InputSelect
                            fullWidth
                            transparent="true"
                            id="naturalnessState"
                            name="naturalnessState"
                            label={
                                translate("workWithUs.form.step3.naturalnessState") + " (*)"
                            }
                            labeldark="false"
                            autoComplete="off"
                            value={dataFields?.basicInformation?.naturalnessState || ""}
                            onChange={(props) =>
                                handleStateChangeSelect(
                                props,
                                "naturalness",
                                "basicInformation",
                                "fetchCities"
                                )
                            }
                            options={listStates}
                            error={errors?.basicInformation?.naturalnessState}
                        />
                    </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={4} xl={4}>
                <GroupField>
                    <InputAutoComplete
                    transparent="true"
                    name="naturalness"
                    id="naturalness"
                    label={translate("workWithUs.form.step3.naturalness") + " (*)"}
                    value={dataFields?.basicInformation?.naturalness || null}
                    onChange={(props, value) =>
                        handleChangeAutocomplete(
                        props,
                        value,
                        "naturalness",
                        "basicInformation"
                        )
                    }
                    options={listCities}
                    error={errors?.basicInformation?.naturalness}
                    />
                </GroupField>
                </Grid>

                <Grid item xs={12} md={12} lg={4} xl={4}>
                <GroupField>
                    <InputAutoComplete
                    transparent="true"
                    name="nationality"
                    id="nationality"
                    label={translate("workWithUs.form.step3.nationality") + " (*)"}
                    value={dataFields?.basicInformation?.nationality || null}
                    onChange={(props, value) =>
                        handleChangeAutocomplete(
                        props,
                        value,
                        "nationality",
                        "basicInformation"
                        )
                    }
                    options={nationalities}

                    error={errors?.basicInformation?.nationality}
                    />
                </GroupField>
                </Grid> */}

                <Grid item xs={12} md={12} lg={6} xl={6}>
                <GroupField>
                    <DatePicker
                    label={translate("workWithUs.form.step3.birthDate") + " (*)"}
                    value={birthDate}
                    onChange={(newValue) =>
                        handleChangeDate(
                        newValue,
                        "basicInformation",
                        "birthDate",
                        setBirthDate(newValue)
                        )
                    }
                    error={errors?.basicInformation?.birthDate}
                    />
                </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={6} xl={6}>
                <GroupField>
                    <InputSelect
                    transparent="true"
                    name="maritalStatus"
                    id="maritalStatus"
                    label={translate("workWithUs.form.step3.maritalStatus") + " (*)"}
                    labeldark="false"
                    value={dataFields?.basicInformation?.maritalStatus || ""}
                    onChange={(props) =>
                        handleChangeSelect(props, "basicInformation")
                    }
                    options={getOptionsMaritalStatus}
                    error={errors?.basicInformation?.maritalStatus}
                    />
                </GroupField>
                </Grid>
                <Grid item xs={12} md={5} lg={5} xl={5}>
                    <GroupField>
                        <InputSelect
                            fullWidth
                            transparent="true"
                            id="hasCnh"
                            name="hasCnh"
                            label={translate("workWithUs.form.step3.hasCnh") + " (*)"}
                            labeldark="false"
                            autoComplete="off"
                            value={dataFields?.basicInformation?.hasCnh || ""}
                            onChange={(props) =>
                                handleChangeText(
                                    props,
                                    "basicInformation",
                                    setCnhRequired(
                                        props.target.value && props.target.value !== "NT"
                                    )
                                )
                            }
                            options={getHasCnhOption}
                            error={errors?.basicInformation?.hasCnh}
                        />
                    </GroupField>
                </Grid>
                {dataFields?.basicInformation?.hasCnh === "SIM" && (
                    <React.Fragment>
                        <Grid item xs={12} md={3} lg={3} xl={3}>
                            <GroupField>
                                <InputSelect
                                    fullWidth
                                    transparent="true"
                                    id="driverLicenceCategory"
                                    name="driverLicenceCategory"
                                    label={translate("workWithUs.form.step3.driverLicenceCategory")}
                                    labeldark="false"
                                    autoComplete="off"
                                    value={dataFields?.basicInformation?.driverLicenceCategory || ""}
                                    onChange={(props) =>
                                        handleChangeText(
                                            props,
                                            "basicInformation",
                                        )
                                    }
                                    options={getDriveLicenceCategories}
                                    error={errors?.basicInformation?.driverLicenceCategory}
                                />
                            </GroupField>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4} xl={4}>
                            <GroupField>
                                <DatePicker
                                    label={
                                    isCnhRequired
                                        ? translate("workWithUs.form.step3.driverExpirationDate") +
                                        " (*)"
                                        : translate("workWithUs.form.step3.driverExpirationDate")
                                    }
                                    value={driverExpirationDate}
                                    onChange={(newValue) =>
                                        handleChangeDate(
                                            newValue,
                                            "basicInformation",
                                            "driverExpirationDate",
                                            setDriverExpirationDate(newValue)
                                        )
                                    }
                                    error={errors?.basicInformation?.driverExpirationDate}
                                />
                            </GroupField>
                        </Grid>
                    </React.Fragment>
                )}
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <InputSelect
                            transparent="true"
                            name="educationLevel"
                            id="educationLevel"
                            label={translate("workWithUs.form.step3.educationLevel") + " (*)"}
                            value={dataFields?.basicInformation?.educationLevel || ""}
                            onChange={(props) =>
                                handleChangeSelect(props, "basicInformation")
                            }
                            options={getOptionsEducationLevel}
                            error={errors?.basicInformation?.educationLevel}
                        />
                    </GroupField>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <br />
                    <br />
                    <Text bold="bold">
                        <Small color="#fff">O Grupo Altum valoriza a inclusão e o respeito em todas as etapas do processo seletivo. Esta pergunta não tem caráter eliminatório. Nosso objetivo é identificar e oferecer apoio a candidatas que estejam em situação de vulnerabilidade relacionada à violência doméstica, sempre com sigilo e acolhimento.</Small>
                    </Text>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <Text bold="bold">
                        {translate("workWithUs.form.step3.vvdmp")}
                        </Text>
                        <InputSelect
                            transparent="true"
                            name="vvdmp"
                            id="vvdmp"
                            label="Já sofreu violência? (*)"
                            value={dataFields?.basicInformation?.vvdmp || ""}
                            onChange={(props) =>
                                handleChangeSelect(props, "basicInformation")
                            }
                            options={getVvdmpOption}
                            error={errors?.basicInformation?.vvdmp}
                        />
                    </GroupField>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default BasicInformation;
